import { useEffect, useState } from 'react';

interface SystemMessageProps {
  children: React.ReactNode;
}

export function SystemMessage({ children }: SystemMessageProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 20);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className={
        'transform-gpu transition-all duration-300 will-change-transform' +
        (visible ? ' translate-y-0 opacity-100' : ' translate-y-2 opacity-0')
      }
    >
      {children}
    </div>
  );
}
